import {StyleSheet} from 'react-native';

import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

import color from './competency.color';

export const backgroundColor = StyleSheet.create({
  [COACH]: {
    backgroundColor: color[COACH].primary,
  },
  [BUSINESS_COACH]: {
    backgroundColor: color[BUSINESS_COACH].primary,
  },
  [BUSINESS_LEADER]: {
    backgroundColor: color[BUSINESS_LEADER].primaryLight,
  },
});
